import { environment } from './../../../environments/environment';
import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable, EventEmitter, Attribute } from '@angular/core';
import { MediaStructure } from '../interfaces/MediaStructure';
import { Observable, of } from 'rxjs';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  submitMedia$ = new EventEmitter();
  submitMediaBulk$ = new EventEmitter<string>();
  constructor(private http: HttpClient) {}

  getMediaAttributeValue(
    AttributeId: string | number,
    ObjType: number,
    ObjKey: number
  ) {
    
    const link = `${AppConfigService.settings.apiUrl}Media?attributeId=${AttributeId}&objType=${ObjType}&objKey=${ObjKey}&withBase64=false`;
    return this.http.get(link);
  }

  getObjectMedia(ObjType: number, ObjKey: number) {
    const link = `${AppConfigService.settings.apiUrl}Media?objType=${ObjType}&objKey=${ObjKey}`;
    return this.http.get(link);
  }

  RemoveMedia(mediaStrucure: MediaStructure,key:number) {
   const link = `${AppConfigService.settings.apiUrl}Media/${mediaStrucure.id}/${key}`;

    return this.http.delete(link);
  }
  upload(
    file: File,
    isCover: boolean,
    keyValue: number,
    objectType: number
  ): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    const ExtraAction = `/UploadMedia?keyValue=${keyValue}&objectType=${objectType}`;
    let link = `${AppConfigService.settings.apiUrl}Media${ExtraAction}`;
    if (isCover === true) {
      link = `${AppConfigService.settings.apiUrl}Media${ExtraAction}/Cover`;
    }

    return this.http.post(link, formData, {
      reportProgress: true,
      responseType: 'json',
    });

  }

  updateObjectMedia(
    objType: number,
    objKey: number,
    mediaStrucures: MediaStructure[]
  ) {
    
    const link = `${AppConfigService.settings.apiUrl}Media/${objType}/${objKey}`;
    mediaStrucures.forEach((mediaStrucure) => {
      const miniMediaStructure: MiniMediaStructure = {
        id: mediaStrucure.id,
        FileID: mediaStrucure.fileID,
        AltText: mediaStrucure.AltText,
        Roles: mediaStrucure.Roles,
        type: '',
        originalName: '',
        appInfo: '',
        MediaLink: '',
        CoverID: '',
        isLink: false,
      };
      this.http.patch(link, miniMediaStructure).subscribe((x: any) => {
        mediaStrucure.id = x;
      });
    });
  }
  getYoutubeVideoInfo(videoID: string, APIKey: any) {
    const YoutubeAPILink = `https://www.googleapis.com/youtube/v3/videos?id=${videoID}&key=${APIKey}&part=snippet,contentDetails,statistics,status`;
    return this.http.get(YoutubeAPILink);
  }

  updateAttributeMedia(
    attributeId: string,
    objType: number,
    objKey: number,
    mediaStrucures: MediaStructure[]
  ) {
    const link = `${AppConfigService.settings.apiUrl}Media/${objType}/${objKey}/${attributeId}`;
    const request: MiniMediaStructure[] = [];
    mediaStrucures.forEach((mediaStrucure) => {
      const miniMediaStructure: MiniMediaStructure = {
        id: mediaStrucure.id,
        FileID: mediaStrucure.fileID,
        AltText: mediaStrucure.AltText,
        Roles: mediaStrucure.Roles,
        type: '',
        originalName: '',
        appInfo: '',
        MediaLink: '',
        CoverID: '',
        isLink: false,
      };
      request.push(miniMediaStructure);
    });

    try {
      this.http.patch(link, request).subscribe((x: any) => {});
    } catch (error) {}
  }

  uploadLink(mediaStrucure: MediaStructure) {
    const link = `${AppConfigService.settings.apiUrl}Media/Link`;
    const miniMediaStructure: MiniMediaStructure = {
      id: mediaStrucure.id,
      FileID: mediaStrucure.fileID,
      AltText: mediaStrucure.AltText,
      Roles: mediaStrucure.Roles,
      CoverID: mediaStrucure.CoverID,
      MediaLink: mediaStrucure.mediaLink,
      appInfo: mediaStrucure.appInfo,
      isHidden: mediaStrucure.isHidden,
      isLink: mediaStrucure.isLink,
      originalName: mediaStrucure.originalName,
      type: mediaStrucure.type,
    };
    return this.http.post<MiniMediaStructure>(link, miniMediaStructure);
  }

  getMedia(attribute: string, productId: number): Observable<Blob> {
      const params = new HttpParams()
        .set('attribute', attribute)
        .set('productId', productId.toString());
  
      return this.http.get(`${AppConfigService.settings.apiUrl}CustomProduct/get-media`, { params,responseType: 'blob' });
    }
 getMediaByCode(code: string): Observable<Blob> {
  const link = `${AppConfigService.settings.apiUrl}CustomProduct/get-media/${code}`;
  
  return this.http.get(link, { responseType: 'blob' });
}
 getMediaByMd5(code: string): Observable<Blob> {
   const link = `${AppConfigService.settings.apiUrl}CustomProduct/get-media/${code}`;
    return this.http.get(link, { responseType: 'blob' });
  }
  convertBlobToBase64(blob: Blob): Observable<string | null> {
  if (!blob || !(blob instanceof Blob)) {
    return of(null);
  }

  return new Observable<string | null>((observer) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      observer.next(reader.result as string);
      observer.complete();
    };

    reader.onerror = () => {
      observer.next(null);
      observer.complete();
    };

    reader.readAsDataURL(blob);
  });
}

}
interface MiniMediaStructure {
  id: string;
  FileID: string;
  AltText: string;
  Roles: string[];
  type?: string;
  originalName?: string;
  appInfo?: string;
  MediaLink?: string;
  isHidden?: boolean;
  isLink?: boolean;
  CoverID?: string;
}
